// extracted by mini-css-extract-plugin
module.exports = {"sectionWrapper":"TableOfContents_sectionWrapper__3nmmK","sectionName":"TableOfContents_sectionName__UikM2"};